const $inject = ['$http', '$q', '$filter', '$rootScope', 'moment', 'APP_CONFIG', 'cartService', 'settingsService'];

const flailService = function flailService($http, $q, $filter, $rootScope, moment, APP_CONFIG, cartService, settingsService) {
  let service = {
    resultsMaster: {flail: []},
    results: {flail: []},
    fareClasses: [],
    hasResults: false,
    currentFilter: undefined,
    init,
    start,
    getResults,
    getFareRules,
    prepData,
    addFilter,
    bulkAddFilters,
    removeFilter,
    setFilters,
    sort,
    itemAddedToCart,
    BulkRemoveFareClassFilter,
    checkFareFilters,
    orderClasses
  };

  const TIME_FORMAT = $filter('translate')('dates.TimeFormatLong');

  function init() {
    service.resultsMaster = {flail: []};
    service.results = {flail: []};
    service.fareClasses = [];
    service.hasResults = false;
    service.currentFilter = undefined;

    $rootScope.$on('cartService:rail:removed', service.checkFareFilters);
  }

  function start(searches) {
    service.getResults('Rail', searches).then(() => {
      service.hasResults = true;
    });
  }


  function getResults(type, searches) {
    const search = searches.Rails[0];
    const returnSearch = searches.Rails[1];

    const apiUrl = `${APP_CONFIG.api.url}${type}/search`;

    const params = {
      searchDate: moment(search.Date, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
      originLocationCode: search.Origin.Code,
      destinationLocationCode: search.Destination.Code,
      paxCount: search.Passengers.length,
      searchIdentifier: search.Identifier,
      railCardCode: search.RailCardCode,
      openReturn: search.OpenReturn
    };

    if (returnSearch) {
      params.searchReturnIdentifier = returnSearch.Identifier;
      params.returnDate = moment(returnSearch.Date, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss')
      params.openReturn = false;
    }

    let deferred = $q.defer();

    $http.get(apiUrl, {params: params})
      .then(res => {
        let data = res.data;

        data.forEach((rail, index) => {
          let orderedData = $filter('orderBy')(rail.Results, 'DepartureTime');
          service.results.flail[index] = prepData(orderedData);
          service.resultsMaster.flail[index] = _.clone(service.results.flail[index]);
        });

        deferred.resolve(true);
      })

      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }


  function getFareRules(type, sector, fare) {
    const deferred = $q.defer();

    if (fare.RemarksCollection) {
      const fareRuleData = () => {
        let text = '';
        _.forEach(fare.RemarksCollection, (obj) => {
          text = text + obj.Code + '\n' + obj.Value + '\n\n';
        });
        return text;
      };

      const fareRules = {
        Type: 'Text',
        Data: fareRuleData()
      };

      deferred.resolve(fareRules);
    } else {
      const apiUrl = `${APP_CONFIG.api.url}${type}/FareRules`;

      const params = {
        carrierCode: sector.Carrier,
        railNumber: sector.RailNumber,
        departureCode: sector.OriginLocationCode,
        departureDate: sector.DepartureDateTime,
        destinationCode: sector.DestinationLocationCode,
        fareCode: fare.Code[0],
        searchIdentifier: sector.SearchIdentifier
      };

      $http.get(apiUrl, {params: params})
        .then(res => {
          let data = res.data;
          deferred.resolve(data);
        })

        .catch(() => {
          deferred.reject();
        });
    }

    return deferred.promise;
  }


  function prepData(data) {

    let availableFilters = {
      priceRange: {
        name: 'priceRange',
        label: 'Price',
        labelSuffix: `(${settingsService.settings.Currency.Code})`,
        isResultsFilter: true,
        settings: {
          type: 'range',
          reference: 'Price',
          filterName: 'flailPriceRangeFilter',
          defaultMax: 0,
          defaultMin: 0,
          maxValue: 0,
          minValue: 0,
          step: 1,
          translateFunc: function (value) {
            return $filter('currency')(value, '', 0);
          },
          isActive: function () {
            return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
          },
          clear: function () {
            this.minValue = this.defaultMin;
            this.maxValue = this.defaultMax;
          }
        }
      },
      departureTimeRange: {
        name: 'departureTimeRange',
        label: 'Departure Time',
        isResultsFilter: true,
        settings: {
          type: 'range',
          reference: 'Departure',
          filterName: 'flailTimeFilter',
          defaultMax: 1439,
          defaultMin: 0,
          maxValue: 1439,
          minValue: 0,
          step: 5,
          translateFunc: translateMinutesTime,
          isActive: function () {
            return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
          },
          clear: function () {
            this.minValue = this.defaultMin;
            this.maxValue = this.defaultMax;
          }
        }
      },
      arrivalTimeRange: {
        name: 'arrivalTimeRange',
        label: 'Arrival Time',
        isResultsFilter: true,
        settings: {
          type: 'range',
          reference: 'Arrival',
          filterName: 'flailTimeFilter',
          defaultMax: 1439,
          defaultMin: 0,
          maxValue: 1439,
          minValue: 0,
          step: 5,
          translateFunc: translateMinutesTime,
          isActive: function () {
            return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
          },
          clear: function () {
            this.minValue = this.defaultMin;
            this.maxValue = this.defaultMax;
          }
        }
      }
    };

    let obj = {
      searchResults: data,
      classes: [],
      activeFilters: {},
      filters: {
        options: availableFilters,
        layout: [['priceRange', 'departureTimeRange', 'arrivalTimeRange']]
      }
    };

    angular.forEach(data, item => {
      let fareClasses = item.FareClasses;
      item.TotalFares = 0;
      item.HasAdditionalFares = false;

      angular.forEach(fareClasses, (fare, key) => {
        if (fare == null) {
          delete fareClasses[key];
        } else {
          fare.Class = key;
          fare.DisplayFare = _.omit(fare, 'AdditionalFares');
          fare.CheapestFare = fare.DisplayFare;

          fare.AdditionalFares = _.map(fare.AdditionalFares, additionalFare => {
            additionalFare.Class = key;
            return additionalFare;
          });

          fare.AdditionalFares.unshift(fare.DisplayFare);

          if (fare.AdditionalFares.length > 1) {
            item.HasAdditionalFares = true;
          }

          item.TotalFares += fare.AdditionalFares.length;
        }
      });

      obj.classes = obj.classes.concat(Object.keys(fareClasses));
      let priceFilterSettings = obj.filters.options.priceRange.settings;

      if (item.MaxRate > priceFilterSettings.maxValue) {
        priceFilterSettings.maxValue = item.MaxRate;
        priceFilterSettings.defaultMax = item.MaxRate;
      }
    });

    buildFareClasses(obj.classes);

    obj.classes = orderClasses(service.fareClasses);

    return obj;
  }

  function buildFareClasses(classes) {
    service.fareClasses = service.fareClasses.concat(classes);
    service.fareClasses = _.uniq(service.fareClasses);

  }

  function bulkAddFilters(filters, target, index, fareClass) {
    _.forOwn(filters, (filter, key) => {
      service.results[target][index].activeFilters[key] = filter;
    });

    if (fareClass) {
      service.results[target][index].activeFilters.fareClass = fareClass;
    }

    service.setFilters(target, index);
  }

  function addFilter(filter, args, target, index) {
    service.results[target][index].activeFilters[filter] = args;
    service.setFilters(target, index);
  }

  function removeFilter(filter, target, index) {
    delete service.results[target][index].activeFilters[filter];
    service.setFilters(target, index);
  }

  function setFilters(target, index) {
    service.results[target][index].searchResults = _.clone(service.resultsMaster[target][index].searchResults);

    $filter('flailCleanFilter')(service.results, target, index, ['filtered', 'priceFiltered', 'noMatch']);

    Object.keys(service.results[target][index].activeFilters).forEach(filter => {
      const args = service.results[target][index].activeFilters[filter];

      if (filter === 'flailTimeFilter') {
        $filter('flailTimeFilter')(service.results, args, target, index, 'DepartureTime');
      }

      if (filter === 'priceRange' && cartService.items.length === 0) {
        $filter('flailPriceRangeFilter')(service.results, args.settings, target, index);
      }

      if (filter === 'departureTimeRange') {
        const obj = {
          start: args.settings.minValue,
          end: args.settings.maxValue
        };

        $filter('flailTimeFilter')(service.results, obj, target, index, 'DepartureTime');
      }

      if (filter === 'arrivalTimeRange') {
        const obj = {
          start: args.settings.minValue,
          end: args.settings.maxValue
        };

        $filter('flailTimeFilter')(service.results, obj, target, index, 'ArrivalTime');
      }

      if (filter === 'matchingFares') {
        $filter('matchingFaresFilter')(service.results, args, target, index);
      }

      if (filter === 'fareClass' && service.results[target][index].itemInCart) {
        $filter('fareClassFilter')(service.results, args, target, index);
      }

    });
  }

  function sort(filterExpression, index) {
    if (service.currentFilter != filterExpression) {
      service.currentFilter = filterExpression;
      $filter('flailGenericFilter')(service.results, filterExpression, index);
    } else {
      service.currentFilter = undefined;
      $filter('flailGenericFilter')(service.results, 'DepartureTime', index);
    }
  }

  function translateMinutesTime(mins) {
    let hours = Math.floor(mins / 60);
    let minutes = mins % 60;

    if(hours === 24 && minutes === 0) {
      hours = 23;
      minutes = 59;
    }

    if (minutes < 10) {
      minutes = '0' + minutes;
    }

    return moment(`${hours}:${minutes}`, 'H:mm').format(TIME_FORMAT);
  }

  function itemAddedToCart(parentIndex, row, item) {
    angular.forEach(service.results.flail, (flail, flailIndex) => {
      if (flailIndex != parentIndex && cartService.items.length === 0) {
        addFilter('matchingFares', item.DisplayFare, 'flail', flailIndex);
        removeFilter('priceRange', 'flail', flailIndex);
        flail.filters.options.priceRange.settings.maxValue = flail.filters.options.priceRange.settings.defaultMax;
        flail.filters.options.priceRange.settings.minValue = flail.filters.options.priceRange.settings.defaultMin;
      }

      if (!flail.itemInCart) {
        addFilter('fareClass', item.Class, 'flail', flailIndex);
      }
    });

    item.orderBy = parentIndex;
    item.parent = service.results.flail[parentIndex];
    item.row = row;
    service.results.flail[parentIndex].itemInCart = true;
    service.results.flail[parentIndex].currentRow = row;
    service.results.flail[parentIndex].currentItem = item;
    item.row.selected = true;
    item.addedToCart = true;
    item.type = 'rail';

    cartService.items.push(item);
  }

  function BulkRemoveFareClassFilter() {
    angular.forEach(service.results.flail, (flail, flailIndex) => {
      removeFilter('fareClass', 'flail', flailIndex);
      removeFilter('matchingFares', 'flail', flailIndex);
    });
  }

  function checkFareFilters() {
    if (cartService.items.length === 0) {
      BulkRemoveFareClassFilter();
    }
  }

  function orderClasses(classes) {
    const classesOrdered = [];

    settingsService.settings.FlightConfiguration.FareClasses.forEach(fareClass => {
      const match = _.find(classes, (className) => {
        return fareClass.Name === className;
      });

      if (match) {
        classesOrdered.push(match);
      }
    });

    return classesOrdered;
  }

  return service;
};


flailService.$inject = $inject;

export default flailService;





// WEBPACK FOOTER //
// ./src/services/flailService.js